import { Component, OnInit, EventEmitter, Input, Output, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Observable } from 'rxjs/Observable';

import { Distributore } from '../../../models/Distributore';
import { BookService } from './../../../services/book.service';

@Component({
  selector: 'app-distributore-selector',
  templateUrl: './distributore-selector.component.html',
  styleUrls: ['./distributore-selector.component.css'],
  providers: [
    BookService,
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DistributoreSelectorComponent),
      multi: true
    }
  ]
})
export class DistributoreSelectorComponent implements OnInit {

  items: Observable<any>;
  selected: Distributore;
  loading: boolean;

  @Input() placeholder: string;
  @Input() required: boolean = false;
  @Input() default: string;
  @Output() notify: EventEmitter<Distributore> = new EventEmitter<Distributore>();

  constructor(private bookService: BookService) { }

  onChange(e: Distributore) {
    this.notify.emit(e);
    this.propagateChange(this.toModel());
  }

  toModel() {
    return this.selected ? {
      codice: this.selected.codice,
      descrizione: this.selected.descrizione,
    } : {}
  }

  set _count(c: number) {
    console.log('_count', c)
  }

  ngOnInit() { }

  private propagateChange = (_: any) => { };

  public writeValue(obj: Distributore) {
    // console.log('======= ************ writeValue', this.placeholder, obj)
    this.loading = true;
    this.items = this.bookService.readDistributore()
      .map(result => {
        this.loading = false;
        if (result.success) {
          if (obj) {
            this.selected = result.items.find(p => p.codice == obj.codice);
          } else {
            if (this.default) {
              this.selected = result.items.find(p => p.codice == this.default);
            }
          }
          this.propagateChange(this.toModel());
          return result.items;
        }
      })
  }

  public registerOnChange(fn: any) {
    this.propagateChange = fn;
  }

  public registerOnTouched() { }
}



// WEBPACK FOOTER //
// ./src/app/components/book/distributore-selector/distributore-selector.component.ts